import { camelize, snakelize } from 'helpers/object';
import { GetCampaignManagersRequestParams, GetCampaignManagersResponse } from './campaignManager.types';

export default (
  $axios: any,
): {
  getCampaignManagers: (data: GetCampaignManagersRequestParams) => Promise<GetCampaignManagersResponse>;
} => ({
  /** 캠페인 담당자 목록 조회 API */
  getCampaignManagers: async (data: GetCampaignManagersRequestParams): Promise<GetCampaignManagersResponse> => {
    return camelize(await $axios.get(`/campaign/managers`, snakelize({ params: data })));
  },
});
